module.exports = __webpack_public_path__ + "img/2fa-not-enabled-icon.a4fe1071.svg";